import {Component} from '@angular/core';
import {DialogAdapter, DialogParams, DialogResult} from '../../models/dialog-param';
import {BUTTON_NAME} from '../../common/constants';
import {SharedValueService} from '../../services/shared-value.service';
import {Subscription} from 'rxjs/Rx';
import {Helper} from '../../common/helper';
declare const $: any;


@Component({
  selector: 'app-modal-room-group',
  templateUrl: './modal-room-group.component.html',
  styleUrls: ['./modal-room-group.component.scss'],
  preserveWhitespaces: false
})
export class ModalRoomGroupComponent implements DialogAdapter {
  params: DialogParams;
  prop: any;
  private isInitial = true;
  isInvalid = false;
  subscription: Subscription;

  constructor(private sharedValueService: SharedValueService,
              private helper: Helper) {
    this.helper._unsubsribe(this.subscription);
    this.subscription = sharedValueService.httpStatus.subscribe(status => {
      if (status) {
        if (this.prop && this.prop.hasOwnProperty('isAPICallError')) {
          this.prop.isAPICallError = false;
        }
        this.params.subject.complete();
        setTimeout(() => {
          (<any>$('#theModal')).modal('hide');
          this.isInitial = true;
          this.helper._unsubsribe(this.subscription);
        });
      } else {
        if (this.prop) {
          this.prop.checkValidate = true;
          if (this.prop.hasOwnProperty('isAPICallError')) {
            this.prop.isAPICallError = true;
          }
        }
      }
    });
  }

  onModalInit() {
    this.prop = this.params.extraParams.initialValue;
    if (this.isInitial) {
      this.isInitial = false;
    } else {
      if (this.checkValidate()) {
        this.prop.checkValidate = false;
        this.params.subject.next(new DialogResult(BUTTON_NAME.OK, this.getPayload()));
      } else {
        this.prop.checkValidate = true;
      }
    }
  }

  getPayload(): any {
    return {
      isAPICallError: this.prop.isAPICallError,
      checkValidate: this.prop.checkValidate,
      model: this.prop.model,
    };
  }

  checkValidate() {
    this.isInvalid = !$('.needs-validation').get(0).checkValidity();

      for (let i = 0; i < this.prop.fields.length; i++) {
        const field = this.prop.fields[i];
        if (this.prop.model.hasOwnProperty(field.key) && field.isRequired) {
          if (!this.prop.model[field.key]) {
            this.isInvalid = true;
          } else {
            if (field.type === 'text') {
              if (this.prop.model[field.key] && this.prop.model[field.key].trim() === '' || !this.prop.model[field.key]) {
                this.isInvalid = true;
              }
            }
          }
        }
      }
    return !this.isInvalid;
  }

  keydownFn(event) {
    return event.keyCode !== 69;
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/modal-room-group/modal-room-group.component.ts